import { DeviceSigningPayload, OtpRequiredResponse } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const postDeviceSigning = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: DeviceSigningPayload
}): Promise<AxiosResponse<OtpRequiredResponse>> => {
  return api.post<OtpRequiredResponse>('/devices/signing', params)
}
